export interface ColumnDef {
  field: string;
  headerName: string;
  sortable: boolean;
  width?: number;
  flex?: number;
  /**
   * 'status'        — dot + text (project/WO status).
   * 'scheduleBadge' — chip built from a ScheduleBadge value (work-orders list
   *                   Schedule column; see DataTable.ScheduleBadgeCell).
   */
  type?: 'status' | 'scheduleBadge';
}

export const projectsColumns: ColumnDef[] = [
  { field: 'ProjectId', headerName: 'Project ID', sortable: true, width: 120 },
  { field: 'ProjectName', headerName: 'Project Name', sortable: true, flex: 1.5 },
  { field: 'SiteName', headerName: 'Site', sortable: true, flex: 1 },
  { field: 'ClientName', headerName: 'Client', sortable: true, flex: 1 },
  { field: 'SiteCity', headerName: 'City', sortable: true, flex: 0.8 },
  { field: 'TotalSamples', headerName: 'Samples', sortable: true, width: 80 },
  { field: 'Status', headerName: 'Status', sortable: true, width: 100, type: 'status' },
  { field: 'ProjectStartDate', headerName: 'Start Date', sortable: true, width: 110 },
  { field: 'ExpectedStartDate', headerName: 'Exp. Start', sortable: true, width: 110 },
  { field: 'ExpectedEndDate', headerName: 'Exp. End', sortable: true, width: 110 },
  { field: 'sysLastModifiedDate', headerName: 'Last Modified', sortable: true, width: 115 },
  { field: 'ApprovalStatus', headerName: 'Approval', sortable: true, width: 100 },
];
